import { Outlet, Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { CircularProgress, Box } from '@mui/material'

const PrivateRoutes = () => {
    const currentUser = useSelector((state) => state.currentUser)
    const initialized = useSelector((state) => state.authInitialized)

    if (!initialized) {
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <CircularProgress sx={{ color: '#d32028' }} />
        </Box>
      )
    }

    if (!currentUser) {
      return <Navigate to="/" />
    }

    return <Outlet/>
}

export default PrivateRoutes
